module.exports = __webpack_public_path__ + "img/course_009.a6931a5.png";